module.exports = __webpack_public_path__ + "img/bedroom-office.48b7cf3.svg";